import React, { useEffect, useRef, useState } from 'react';
import './NetplayRoom.host-override.css';
const MESSAGES = {
  DENIED: 'Host override was denied. Check the code and try again.',
  RATE_LIMIT: 'Too many host override attempts. Try again in 15 minutes.',
  NOT_JOINED: 'Join this game room before requesting host override.',
  JOIN_FAILED: 'This tab could not join as a separate member. Close an unused game tab and retry.',
  UNAVAILABLE: 'Host override is unavailable. Reconnect and try again.'
};
export default function HostOverride({ request, disabled, cloneConflict = false }) {
  const [open, setOpen] = useState(false), [pin, setPin] = useState(''), [pending, setPending] = useState(false), [message, setMessage] = useState('');
  const active = useRef(true), timer = useRef(), inFlight = useRef(false), sequence = useRef(0);
  useEffect(() => { active.current = true; return () => { active.current = false; sequence.current++; clearTimeout(timer.current); }; }, []);
  useEffect(() => {
    if (disabled) { clearTimeout(timer.current); sequence.current++; inFlight.current = false; setPin(''); setPending(false); }
  }, [disabled]);
  const submit = event => {
    event.preventDefault();
    if (disabled || inFlight.current || !/^[0-9]{4}$/.test(pin)) return;
    const entered = pin, attempt = ++sequence.current; setPin(''); setMessage(''); setPending(true); inFlight.current = true;
    const done = result => {
      if (!active.current || !inFlight.current || attempt !== sequence.current) return;
      clearTimeout(timer.current); inFlight.current = false; setPending(false);
      if (result?.ok === true) { setOpen(false); setMessage('Host changed. Refreshing this room…'); }
      else setMessage(MESSAGES[result?.code] || MESSAGES.UNAVAILABLE);
    };
    timer.current = setTimeout(() => done({ code: 'UNAVAILABLE' }), 10000);
    try { request(entered, done); } catch { done({ code: 'UNAVAILABLE' }); }
  };
  return <div className="netplay-host-override">
    <button type="button" disabled={disabled || pending} aria-expanded={open} onClick={() => { setPin(''); setMessage(''); setOpen(!open); }}>Host Override</button>
    {open && <form onSubmit={submit} aria-label="Host override">
      <p>{cloneConflict ? 'This tab shares another tab’s session. Submitting creates a separate member without disconnecting that tab. ' : ''}Enter the room recovery code to become host and refresh this room. Guests may use it too.</p>
      <label>Recovery code<input aria-label="Host override code" type="password" inputMode="numeric" pattern="[0-9]{4}" maxLength={4} autoComplete="off" value={pin} disabled={disabled || pending} onChange={e => setPin(e.target.value.replace(/[^0-9]/g, '').slice(0, 4))}/></label>
      <div><button type="submit" disabled={disabled || pending || !/^[0-9]{4}$/.test(pin)}>{pending ? 'Requesting…' : 'Take host & refresh'}</button><button type="button" disabled={pending} onClick={() => { setPin(''); setOpen(false); setMessage(''); }}>Cancel</button></div>
    </form>}
    {message && <span role="status">{message}</span>}
  </div>;
}
